import React from 'react';

import './style.css';

export type CheckboxProps = {
  accessibilityLabel: string,
  label: string,
  value: boolean,
  onChange: () => void;
};

export const Checkbox = ({ accessibilityLabel, label, value, onChange }: CheckboxProps) => {
  return (
    <label className='label-text' aria-label={accessibilityLabel}>
      <div className='checkbox-and-text-container' >
        <div className='checkbox-container'>
          <input className='checkbox-input' type="checkbox" checked={value} onChange={onChange} />
        </div>
        <p className='text'>
          {label}
        </p>
      </div>
    </label>
  );
};
